import { useState, useEffect, useRef } from 'react';
import { buscarClienteApi, crearTicketApi, subirArchivoTicketApi } from '../api';

const SISTEMAS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'vuepacs_carestream', label: 'VUEPACS Carestream (legacy)' },
  { value: 'vuepacs_philips',    label: 'VUEPACS Philips (nueva)' },
  { value: 'otro',               label: 'Otro' },
];

const inp = {
  width: '100%', padding: '10px 12px', border: '1px solid #ddd',
  borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none'
};
const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 };
const sec = { fontSize: 11, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 12 };

export default function NuevoTicket() {
  const [form, setForm] = useState({
    contacto_nombre: '', contacto_apellido: '', contacto_email: '',
    contacto_telefono: '', cliente_id: '', cliente_nombre_libre: '',
    sistema: '', version: '', asunto: '', descripcion: '', prioridad: 'normal', adjunto: null
  });
  const [busqueda, setBusqueda] = useState('');
  const [sugerencias, setSugerencias] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [exito, setExito] = useState(null);
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const busquedaTimer = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (busqueda.length < 2) { setSugerencias([]); return; }
    clearTimeout(busquedaTimer.current);
    busquedaTimer.current = setTimeout(async () => {
      try {
        const res = await buscarClienteApi(busqueda);
        setSugerencias(res.data);
      } catch { setSugerencias([]); }
    }, 300);
  }, [busqueda]);

  const seleccionarCliente = (c) => {
    setForm({ ...form, cliente_id: c.id, cliente_nombre_libre: c.nombre, sistema: c.sistema || '', version: c.version || '' });
    setBusqueda(c.nombre);
    setSugerencias([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.contacto_nombre || !form.contacto_email || !form.asunto || !form.descripcion)
      return setError('Completa todos los campos obligatorios');
    setEnviando(true);
    try {
      const payload = { ...form, contacto_nombre: `${form.contacto_nombre} ${form.contacto_apellido}`.trim() };
      if (!form.cliente_id) { payload.cliente_id = null; payload.cliente_nombre_libre = busqueda; }
      delete payload.adjunto;
      const res = await crearTicketApi(payload);
      if (form.adjunto && form.adjunto.length > 0) {
        try {
          const fd = new FormData();
          form.adjunto.forEach(file => fd.append('archivo', file));
          await subirArchivoTicketApi(res.data.id, fd);
        } catch(e) { console.error('Error al subir adjunto:', e); }
      }
      setExito(res.data);
    } catch(err) {
      setError(err.response?.data?.error || 'Error al enviar. Intenta nuevamente.');
    } finally { setEnviando(false); }
  };

  const resetForm = () => {
    setExito(null);
    setForm({ contacto_nombre: '', contacto_apellido: '', contacto_email: '', contacto_telefono: '', cliente_id: '', cliente_nombre_libre: '', sistema: '', version: '', asunto: '', descripcion: '', prioridad: 'normal', adjunto: null });
    setBusqueda('');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(160deg, #0a2a4a 0%, #0d4a2a 100%)', padding: '2rem 1rem 1.5rem' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <svg width="200" height="56" viewBox="0 0 160 60" style={{ display: 'block', margin: '0 auto' }}>
            <ellipse cx="28" cy="30" rx="22" ry="22" fill="none" stroke="#5aabdd" strokeWidth="7" strokeDasharray="115 25" strokeDashoffset="15"/>
            <ellipse cx="28" cy="30" rx="14" ry="14" fill="none" stroke="#6dd68a" strokeWidth="5" strokeDasharray="65 23" strokeDashoffset="-10"/>
            <text x="56" y="36" fontSize="22" fill="#ffffff" fontWeight="700" fontFamily="Arial,sans-serif">euroswiss</text>
          </svg>
          <p style={{ fontSize: 20, fontWeight: 600, color: '#fff', marginTop: 8 }}>Reportar un problema</p>
          <p style={{ fontSize: 13, color: '#9ecfb8', marginTop: 4 }}>Soporte tecnico VUEPACS · Te contactaremos a la brevedad</p>
        </div>

		<div style={{ display: 'flex', alignItems: 'flex-start', width: '100%', marginBottom: '1.5rem' }}>
          {['Contacto', 'Institucion', 'Problema'].map((label, i) => (
            <div key={label} style={{ display: 'contents' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 80 }}>
                <div style={{ width: 28, height: 28, borderRadius: '50%', border: '2px solid #1a6fbb', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#1a6fbb' }}>{i + 1}</div>
                <span style={{ fontSize: 11, color: '#fff', marginTop: 4, textAlign: 'center' }}>{label}</span>
              </div>
              {i < 2 && <div style={{ flex: 1, height: 2, background: i === 0 ? '#1a6fbb' : 'rgba(255,255,255,0.2)', marginTop: 14 }}/>}
            </div>
          ))}
        </div>

        {exito ? (
          <div style={{ background: '#fff', borderRadius: 12, padding: '2.5rem', textAlign: 'center', maxWidth: 500, margin: '0 auto' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
            <p style={{ fontSize: 18, fontWeight: 700, color: '#111', marginBottom: 8 }}>Ticket creado exitosamente</p>
            <p style={{ fontSize: 28, fontWeight: 700, color: '#1a6fbb', marginBottom: 12 }}>{exito.numero}</p>
            <p style={{ fontSize: 13, color: '#666', marginBottom: 24, lineHeight: 1.6 }}>
              Recibiras una confirmacion en tu correo. Nuestro equipo tecnico se pondra en contacto a la brevedad.
            </p>
            <button onClick={resetForm} style={{ background: '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
              Reportar otro problema
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div style={{ background: '#fff', borderRadius: 12, padding: '1.5rem' }}>
                <p style={sec}>1 - Datos de contacto</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Nombre *</label>
                    <input type="text" placeholder="Juan" value={form.contacto_nombre} onChange={e => setForm({ ...form, contacto_nombre: e.target.value })} required style={inp}/>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Apellido</label>
                    <input type="text" placeholder="Perez" value={form.contacto_apellido} onChange={e => setForm({ ...form, contacto_apellido: e.target.value })} style={inp}/>
                  </div>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Correo electronico *</label>
                  <input type="email" placeholder="jperez@hospital.com.ar" value={form.contacto_email} onChange={e => setForm({ ...form, contacto_email: e.target.value })} required style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Telefono / interno</label>
                  <input type="text" placeholder="+54 11 1234-5678" value={form.contacto_telefono} onChange={e => setForm({ ...form, contacto_telefono: e.target.value })} style={inp}/>
                </div>

                <div style={{ height: 1, background: '#eee', margin: '16px 0' }}/>

                <p style={sec}>2 - Institucion</p>
                <div style={{ marginBottom: 14, position: 'relative' }}>
                  <label style={lbl}>Nombre de la institucion *</label>
                  <input type="text" placeholder="Busca o escribe el nombre..." value={busqueda} onChange={e => { setBusqueda(e.target.value); setForm({ ...form, cliente_id: '', cliente_nombre_libre: e.target.value }); }} style={{ ...inp, fontSize: 15, padding: '12px 14px' }}/>
                  <p style={{ fontSize: 13, color: '#666', marginTop: 6, fontStyle: 'italic' }}>Si no encontras tu institucion, escribe el nombre completo y lo registramos automaticamente.</p>
                  {sugerencias.length > 0 && (
                    <div style={{ position: 'absolute', top: '72px', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 8, zIndex: 100, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                      {sugerencias.map(s => (
                        <div key={s.id} onClick={() => seleccionarCliente(s)}
                          style={{ padding: '10px 12px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f5f5f5', color: '#111' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                          onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                          <strong>{s.nombre}</strong>
                          <span style={{ color: '#888', fontSize: 11 }}> - {s.tipo}{s.ciudad ? ` - ${s.ciudad}` : ''}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Sistema *</label>
                    <select value={form.sistema} onChange={e => setForm({ ...form, sistema: e.target.value })} style={inp}>
                      {SISTEMAS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Version instalada</label>
                    <input type="text" placeholder="ej: 4.2.0" value={form.version} onChange={e => setForm({ ...form, version: e.target.value })} style={inp}/>
                  </div>
                </div>
              </div>

              <div style={{ background: '#fff', borderRadius: 12, padding: '1.5rem' }}>
                <p style={sec}>3 - Detalle del problema</p>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Asunto *</label>
                  <input type="text" placeholder="Descripcion breve del problema" value={form.asunto} onChange={e => setForm({ ...form, asunto: e.target.value })} required style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Descripcion detallada *</label>
                  <textarea rows={isMobile ? 4 : 7} placeholder="Cuando ocurre el problema? Hay mensaje de error? Afecta a una o varias estaciones?" value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })} required style={{ ...inp, resize: 'vertical' }}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Prioridad</label>
                  <select value={form.prioridad} onChange={e => setForm({ ...form, prioridad: e.target.value })} style={inp}>
                    <option value="normal">Normal</option>
                    <option value="alta">Alta - sistema sin funcionar</option>
                    <option value="baja">Baja - consulta o sugerencia</option>
                  </select>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Adjuntar archivos (opcional)</label>
                  <div onClick={() => document.getElementById('adjunto-publico').click()}
                    style={{ border: '1.5px dashed #ccc', borderRadius: 8, padding: '16px', textAlign: 'center', cursor: 'pointer', background: '#fafafa' }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = '#1a6fbb'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = '#ccc'}>
                    <div style={{ fontSize: 20, marginBottom: 4 }}>📎</div>
                    <p style={{ fontSize: 13, color: '#888' }}>
                      {form.adjunto && form.adjunto.length > 0 ? `${form.adjunto.length} archivo(s) seleccionado(s)` : 'Hace clic para seleccionar archivos'}
                    </p>
                    <p style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>JPG, PNG, PDF - max. 10MB por archivo</p>
                  </div>
                  <input id="adjunto-publico" type="file" style={{ display: 'none' }} accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx" multiple onChange={e => setForm({ ...form, adjunto: Array.from(e.target.files) })}/>
                </div>
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 12, padding: '1.25rem' }}>
              {error && <p style={{ color: '#e24b4a', fontSize: 12, marginBottom: 12, textAlign: 'center' }}>{error}</p>}
              <button type="submit" disabled={enviando} style={{ width: '100%', padding: 13, background: enviando ? '#0c447c' : '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: enviando ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, transition: 'background 0.2s' }}>
                {enviando ? (
                  <>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
                      </path>
                    </svg>
                    Generando ticket...
                  </>
                ) : 'Enviar solicitud'}
              </button>
              <p style={{ textAlign: 'center', fontSize: 14, color: '#666', marginTop: 10 }}>
                Recibiras una confirmacion por correo con tu numero de ticket
              </p>
            </div>
          </form>
        )}

        <p style={{ textAlign: 'center', fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 14 }}>
          Euroswiss S.A. 2026 - Soporte tecnico VUEPACS
        </p>
      </div>
    </div>
  );
}